package team.platforma.dictionary_data.network

import kotlinx.serialization.Serializable

@Serializable
data class AiModelGroup(
    val ai_model_group_id: Long,
    val created_at: String,
//    val deleted_at: Any,
    val description: String,
    val title: String
)